<app-page-header title="Sistemi" [showBack]="false">
  <div class="d-flex align-items-center">
    @if (authService.hasRole('SYSTEM_CAN_WRITE')) {
    <button class="mr-4" mat-flat-button color="primary" [routerLink]="['new']">Crea Sistema</button>
    }

    <bitf-search
      (valueChanges)="searchText = $event"
      placeholder="Cerca sistema"
      label="Cerca sistema"
      [isInToolbar]="true"
      [hasSearchIcon]="false"
    ></bitf-search>
  </div>
</app-page-header>

<div class="container-fluid py-3">
  <app-dynamic-table
    [service]="systemService"
    [columns]="dataColumns"
    [showDeleteBtn]="authService.hasRole('SYSTEM_CAN_DELETE')"
    [searchText]="searchText"
  ></app-dynamic-table>
</div>
